import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 21,
	viewBox: "0 0 22 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.2 19.1H10.6C5.9 19.1 2.1 15.3 2.1 10.6C2.1 5.9 5.8 2 10.5 2H11.1C11.7 2 12.1 1.6 12.1 1C12.1 0.4 11.7 0 11.1 0H10.5C4.7 0 0 4.7 0 10.5C0 16.3 4.7 21 10.5 21H11.1C11.7 21 12.1 20.6 12.1 20C12.1 19.4 11.7 19.1 11.2 19.1Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.4 10L15.7 4.3C15.3 3.9 14.7 3.9 14.3 4.3C13.9 4.7 13.9 5.3 14.3 5.7L18.3 9.7H8.70001C8.10001 9.7 7.70001 10.1 7.70001 10.7C7.70001 11.3 8.10001 11.7 8.70001 11.7H18.3L14.3 15.7C13.9 16.1 13.9 16.7 14.3 17.1C14.5 17.3 14.8 17.4 15 17.4C15.2 17.4 15.5 17.3 15.7 17.1L21.4 11.4C21.6 11.2 21.7 11 21.7 10.7C21.7 10.4 21.6 10.1 21.4 10Z",
		fill: "white"
	})]
});
export default SvgLogout;
